import { createSlice } from '@reduxjs/toolkit';
import type { PassportFull } from 'src/types/Passport';
import { urls } from 'src/utils/api';
import { protectedAxios as axios } from 'src/utils/auth';
import type { PayloadAction } from '@reduxjs/toolkit';
import type { AppThunk } from 'src/store';
import objCamelToSnakeCase from 'src/utils/editStringCase';
import deepMergeObj from 'src/utils/deepMergeObj';

interface CurrentPassportState {
  passport: PassportFull | null;
}

const initialState: CurrentPassportState = {
  passport: null
};

const slice = createSlice({
  name: 'currentPassport',
  initialState,
  reducers: {
    setCurrentPassport(
      state: CurrentPassportState,
      action: PayloadAction<PassportFull>
    ) {
      state.passport = action.payload;
    }
  }
});

export const fetchCurrentPassport = (passportId: number): AppThunk => async (
  dispatch
) => {
  const { data } = await axios.get<PassportFull>(
    `${urls.passports}${passportId}/`
  );
  dispatch(slice.actions.setCurrentPassport(data));
};

export const updateCurrentPassport = (
  passportId: number,
  newData: any
): AppThunk => async (dispatch, getState) => {
  const {
    currentPassport: { passport }
  } = getState();

  const {
    common_property: commonProperty,
    main_package: mainPackage,
    organization_owner: organizationOwner,
    organization_creator: organizationCreator,
    organization_provider: organizationProvider,
    organization_carrier: organizationCarrier,
    package: passportPackage,
    number,
    since,
    contract_number: contractNumber,
    contract_number_since: contractNumberSince,
    individual_number: individualNumber,
    status_rao: statusRao
  } = passport;
  const { data } = await axios.put<PassportFull>(
    `${urls.passportById(passportId)}?id=${passportId}`,
    deepMergeObj(objCamelToSnakeCase(JSON.parse(JSON.stringify(newData))), {
      common_property: commonProperty,
      main_package: mainPackage,
      organization_owner: organizationOwner,
      organization_creator: organizationCreator,
      organization_provider: organizationProvider,
      organization_carrier: organizationCarrier,
      package: passportPackage,
      number,
      since,
      contract_number: contractNumber,
      contract_number_since: contractNumberSince,
      individual_number: individualNumber,
      status_rao: statusRao
    })
  );

  dispatch(slice.actions.setCurrentPassport(data));
};

export const { reducer } = slice;

export default slice;
